import {useQuery} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import { LocalDateTimeFormatISO } from "../../../Utils/DateFormatPatternUtils";
import { isValid } from "date-fns";

const apiUrl = "api/audit/alarm/search";

const searchAlarms = async (pagedSearchParams: PagedSearchParams) => {
    try {
        const response = await axios
            .get(apiUrl, {
                params: pagedSearchParams ? pagedSearchParams.toURLSearchParams() : null,
                timeout: 30000,
            })
            .then((res) => res.data);

        return response ?? 0;
    } catch (error : any) {
        console.error("Error fetching data:", error);
        return error.response?.data?.message || "An error occurred while fetching data.";
    }
};

export const AuditAlarmsQuery = (pagedSearchParams: PagedSearchParams, startDatetime: Date, endDatetime: Date) => {
    const isValidRange = isValid(startDatetime) && isValid(endDatetime);
    const nextParams = new PagedSearchParams(
        JSON.parse(JSON.stringify(pagedSearchParams.filters)),
        pagedSearchParams.page,
        pagedSearchParams.size
    );

    if (isValidRange) {
        nextParams.filters.push({name: "dateTime", condition: "starts-at", value: LocalDateTimeFormatISO(startDatetime), sort: "none"});
        nextParams.filters.push({name: "dateTime", condition: "ends-at", value: LocalDateTimeFormatISO(endDatetime), sort: "none"});
    }

    return useQuery({
        queryKey: ["data", isValidRange ? nextParams.toURLSearchParams().toString() : "invalid-range"],
        queryFn: () => searchAlarms(nextParams),
        enabled: isValidRange,
    });
};